export { default as PetDetails } from "./PetDetails";
